/**
 * 正则表达式常量
 */
//export const PWD_REG = /^[A-Za-z0-9]{6,20}$/;//密码6-20由字母和数字组成
export const PWD_REG = /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?!\W+$)\S{8,20}$/;//密码6-20位由字母和数字组成
//export const PWD_REG = /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?!\W+$)(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)(?![A-Za-z\d]+$)(?![A-Za-z\W]+$)(?![A-Z\d\W]+$)(?![a-z\d\W]+$)\S{6,16}$/;//密码6-16由小写，大写字母，数字，特殊字符组成

export const HTML_REG = /[<>&"]/g;// 全局搜索"<" , "" ,">"进行转义，防止XSS注入
